import React from 'react';
const Trustpilot = (props) => {
  // Create a reference to the <div> element which will represent the TrustBox
  const ref = React.useRef(null);
  React.useEffect(() => {
    const script = document.createElement('script');
    script.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.async = true;
    document.body.appendChild(script);
    // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
    // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
    // When it is, it will automatically load the TrustBox.
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
    return () => {
      document.body.removeChild(script);
    }
  }, [props.templateId]); // Perform only when props.templateId changes
  return (
    <div ref={ref} // We need a reference to this element to load the TrustBox in the effect.
        className="trustpilot-widget d-flex" // Renamed this to className.
        data-locale="en-US"
        data-template-id={props.templateId}
        data-businessunit-id="570d40500000ff00058b6dbe"
        data-style-height="24px"
        data-style-width="100%"
        style={{justifyContent: 'center'}}>
        <a href="https://www.trustpilot.com/review/example.com" target="_blank" rel="noopener"> Trustpilot </a>
    </div>
  );
};
export default Trustpilot;